const normalizeName = (name) => name?.trim().replace(/\s+/g, ' ') || '';

export const getApiErrorForName = (apiErrors, name) => {
    if (!apiErrors || !name) return null;

    const normalizedName = normalizeName(name);
    if (apiErrors[normalizedName]) return apiErrors[normalizedName];
    if (apiErrors[name]) return apiErrors[name];

    const matchedKey = Object.keys(apiErrors).find(
        (key) => normalizeName(key).toLowerCase() === normalizedName.toLowerCase(),
    );

    return matchedKey ? apiErrors[matchedKey] : null;
};

export const mapBulkApiErrorsToFields = (items, apiErrors) =>
    items.map((item) => {
        const errorMessage = getApiErrorForName(apiErrors, item.name);
        return errorMessage ? { name: errorMessage } : {};
    });
